import React, { useState } from "react";
import { toast } from "react-toastify";
import { useUpdateModelMutation } from "../../../Services/vehicle/Vehicle";
import useThemeColors from "../ThemeColors";

interface IPROPS {
  closeModal: any;
  refetchingData: any;
  storedData: any;
}

const EditModel: React.FC<IPROPS> = ({
  closeModal,
  refetchingData,
  storedData,
}) => {
  const {
    selectedColor,
    selectedBackgroundColor,
    selectedBorderColor,
    selectedButtonBackgoundColors,
    selectedButtonColors,
  } = useThemeColors();

  const [name, setName] = useState(storedData?.name);
  const [brandName, setBrandName] = useState(storedData?.brand?.name);

  const [
    trigger,
    { isLoading: updatePauseCodeloading, status: updatePauseCodeStatus },
  ] = useUpdateModelMutation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const obja = {
      name: name,
    };

    const response = await trigger({ body: obja, id: storedData?.id });

    try {
      if (response?.data) {
        toast.success("Edited successfully");
        closeModal();
        refetchingData();

        setTimeout(() => {}, 3000);
      } else if ("data" in response?.error) {
        const errorData = response?.error?.data as {
          extension: string[];
        };
        const errorMessage = errorData?.extension[0];
        toast.error(errorMessage);
      }
    } catch (error) {
      toast.error("An error occured");
    }
  };

  return (
    <div
      style={{
        fontFamily: "karbon-medium",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <div>
        <p
          style={{
            margin: "0",
            fontSize: "20px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          Edit Model
        </p>
      </div>

      <div>
        <label>Brand</label>
        <input
          className="form-control"
          value={brandName}
          onChange={(e) => setBrandName(e.target.value)}
          disabled
        />
      </div>
      <div>
        <label>Model</label>
        <input
          className="form-control"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          gap: "10px",
          justifyContent: "end",
        }}
      >
        <button
          type="reset"
          className="btn btn-sm btn-white me-2"
          onClick={() => closeModal()}
        >
          Cancel
        </button>
        <button
          onClick={handleSubmit}
          style={{
            color: `${selectedButtonColors}`,
            background: `${selectedButtonBackgoundColors}`,
            border: "none",
            padding: "10px 15px",
            borderRadius: "20px",
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default EditModel;
